<template>
    <BlogPaginationList
        :title="$t('newsBlogPage.heading')"
        postsTag="NEWS_LAND_USE"
        routeName="news_blog"
        :limit="3">
    </BlogPaginationList>
</template>

<script>
import BlogPaginationList from '@/components/blog/BlogPaginationList';
export default {
    components: {
        BlogPaginationList
    }
}
</script>
